"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.LinkDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var icon_1 = require("./icon");
exports.LinkDefaultProps = {
  stopPropagation: true,
  inverted: false,
  to: '/',
  spacing: 2,
  inline: false,
  iconSize: 18,
  iconAtEnd: false,
  target: '_blank'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    cursor: pointer;\n    text-decoration: none;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    color: ", ";\n    ", ";\n\n\n    &:hover {\n      color: ", ";\n      ", ";\n\n      .shp-cell-label {\n        color: ", ";\n      }\n\n    }\n\n    ", "\n\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    cursor: pointer;\n    text-decoration: none;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    color: ", ";\n    ", ";\n\n\n    &:hover {\n      color: ", ";\n      ", ";\n\n      .shp-cell-label {\n        color: ", ";\n      }\n\n    }\n\n    ", "\n\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'), theme_1.theme.COLOR('primary'), function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: 0.5;\n    "], ["\n      opacity: 0.5;\n    "])));
  })
});
var ContainerInvertedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n    ", ";\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "], ["\n    ", ";\n    color: ", ";\n    ", ";\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "])), ContainerStyles, theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-shrink: 0;\n\n    ", "\n    \n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    flex-shrink: 0;\n\n    ", "\n    \n    ", "\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme_1.theme.UNIT(props.spacing));
  }, function (props) {
    return props.priority === "text" && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }, function (props) {
    return props.iconAtEnd && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-left: ", ";  \n    "], ["\n      margin-left: ", ";  \n    "])), theme_1.theme.UNIT(2));
  }, function (props) {
    return !props.hasText && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      margin-right: 0;\n    "], ["\n      margin-right: 0;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var TextStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.priority === "icon" && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: inline;\n  "], ["\n    display: inline;\n  "])))
});
// -------- Components -------->
var My = {
  A: styled_components_1.default.a(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InvertedA: styled_components_1.default.a(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerInvertedStyles),
  Link: (0, styled_components_1.default)(router_1.Link)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InvertedLink: (0, styled_components_1.default)(router_1.Link)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerInvertedStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Text: styled_components_1.default.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TextStyles)
};
var Link = function (props) {
  var className = props.className,
    icon = props.icon,
    iconAtEnd = props.iconAtEnd,
    children = props.children,
    spacing = props.spacing,
    to = props.to,
    stopPropagation = props.stopPropagation,
    inverted = props.inverted,
    target = props.target,
    inline = props.inline,
    iconSize = props.iconSize,
    onClick = props.onClick,
    download = props.download,
    disabled = props.disabled,
    priority = props.priority;
  var handleClick = function (event) {
    if (stopPropagation || onClick) {
      event.stopPropagation();
      if (onClick) {
        onClick();
      }
    }
  };
  var swallowClick = function (event) {
    if (disabled) {
      event.preventDefault();
    }
  };
  var isHref = !!(to && (to.match(/tel:/i) || to.match(/data:/i) || to.match(/mailto:/i) || to.match(/http(s?)/)));
  var isAnchor = onClick || isHref;
  var Container = isAnchor ? inverted ? My.InvertedA : My.A : inverted ? My.InvertedLink : My.Link;
  var attr = {};
  if (disabled) {
    attr.onClick = swallowClick;
    attr.to = '#';
    attr.style = {
      opacity: 0.2,
      cursor: 'default'
    };
  } else {
    if (isHref) {
      attr.href = to;
      attr.target = target;
    } else {
      attr.onClick = handleClick;
    }
    if (!isHref && !isAnchor) {
      attr.to = to;
    }
    if (download) {
      attr.download = download;
    }
  }
  return /* @ts-ignore */React.createElement(Container, __assign({}, attr, {
    style: inline ? {
      display: 'inline'
    } : {},
    className: className
  }), icon && !iconAtEnd && React.createElement(My.Icon, {
    spacing: spacing,
    priority: priority,
    size: iconSize,
    hasText: Boolean(children)
  }, icon), React.createElement(My.Text, {
    priority: priority
  }, children), icon && iconAtEnd && React.createElement(My.Icon, {
    priority: priority,
    iconAtEnd: true,
    size: iconSize,
    hasText: Boolean(children)
  }, icon));
};
exports.Link = Link;
exports.Link.defaultProps = exports.LinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;